// NotificationBell — bell icon button with unread indicator dot.
//
// Pure presentational component. Shows a small red dot on the bell (not a
// count badge) when there are unread notifications.
//
// btnRef is forwarded so the position hook can measure the button.

import { Bell } from 'lucide-react';
import { useT } from '../i18n/index.js';

export interface NotificationBellProps {
  unreadCount: number;
  open: boolean;
  btnRef: React.RefObject<HTMLButtonElement>;
  onClick: () => void;
}

export function NotificationBell({ unreadCount, open, btnRef, onClick }: NotificationBellProps) {
  const t = useT();
  const hasUnread = unreadCount > 0;

  return (
    <button
      ref={btnRef}
      type="button"
      className={`notif-bell-btn${hasUnread ? ' has-unread' : ''}`}
      aria-label={t('notif.centerTitle')}
      aria-expanded={open}
      onClick={onClick}
    >
      <Bell size={18} aria-hidden="true" />
      {hasUnread && <span className="notif-dot" aria-hidden="true" />}
    </button>
  );
}
